"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReglFrame = void 0;
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var regl_1 = __importDefault(require("regl"));
var renderer_1 = __importDefault(require("../renderer"));
var reactRegl_1 = __importDefault(require("../reactRegl"));
var Node_1 = __importDefault(require("../nodes/Node"));
var ReglFrame = /** @class */ (function (_super) {
    __extends(ReglFrame, _super);
    function ReglFrame() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.canvasRef = null;
        _this.initQueue = [];
        return _this;
    }
    ReglFrame.prototype.getChildContext = function () {
        return {
            reactify: true
        };
    };
    ReglFrame.prototype.componentWillUnmount = function () {
        var _this = this;
        if (!this.rootNode) {
            console.error('regl root node missing on component unmount?');
            reactRegl_1.default.setQueue(this.initQueue.slice(0));
            if (this.tick)
                this.tick.cancel();
            if (this.regl) {
                this.regl.destroy();
            }
            reactRegl_1.default.setRegl();
        }
        else {
            renderer_1.default.updateContainer(null, this.rootNode, this, function () {
                reactRegl_1.default.setQueue(_this.initQueue.slice(0));
                if (_this.tick)
                    _this.tick.cancel();
                if (_this.regl) {
                    _this.regl.destroy();
                }
                reactRegl_1.default.setRegl();
            });
        }
    };
    ReglFrame.prototype.componentDidMount = function () {
        var _this = this;
        var canvasRef = this.props.canvasRef || this.canvasRef;
        var initProps = {};
        if (canvasRef) {
            var gl = canvasRef.getContext("webgl", {
                alpha: false,
                antialias: false,
                stencil: false,
                preserveDrawingBuffer: false
            });
            if (!gl)
                throw new Error('failed to aquire a gl context for regl');
            initProps.gl = gl;
        }
        if (this.props.extensions)
            initProps.extensions = this.props.extensions;
        if (this.props.optionalExtensions)
            initProps.optionalExtensions = this.props.optionalExtensions;
        var reglHandle = regl_1.default(initProps);
        if (this.props.forwardedRef) {
            //@ts-ignore
            this.props.forwardedRef.current = reglHandle._gl.canvas;
        }
        this.initQueue = reactRegl_1.default.queue.slice(0);
        reactRegl_1.default.setRegl(reglHandle);
        this.regl = reactRegl_1.default;
        var rootNode = renderer_1.default.createContainer(new Node_1.default({ id: 'react-regl-root' }), false, false);
        this.rootNode = rootNode;
        this.regl.on('lost', function () {
            console.error('Regl WebGL context lost');
            if (_this.props.onLost)
                _this.props.onLost();
        });
        this.regl.on('restore', function () {
            console.log('Regl WebGL context restored');
            if (_this.props.onRestore)
                _this.props.onRestore();
        });
        var color = this.props.color ? this.props.color : [0, 0, 0, 1];
        this.regl.clear({
            color: color,
            depth: this.props.depth || 1
        });
        renderer_1.default.updateContainer(this.props.children, this.rootNode, this, function () {
            rootNode.containerInfo.render();
        });
        if (this.props.onFrame && typeof this.props.onFrame === 'function') {
            this.tick = this.regl.frame(function () {
                var _a;
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                if (_this.props.onFrame)
                    (_a = _this.props).onFrame.apply(_a, args);
                if (_this.rootNode)
                    _this.rootNode.containerInfo.render();
            });
        }
    };
    ReglFrame.prototype.componentDidUpdate = function (prevProps, prevState) {
        var _this = this;
        if (prevProps.width !== this.props.width ||
            prevProps.height !== this.props.height) {
            if (this.regl) {
                this.regl.poll();
            }
        }
        if (!this.rootNode)
            throw new Error("regl rootNode was undefined...");
        renderer_1.default.updateContainer(this.props.children, this.rootNode, this, function () {
            if (!_this.rootNode)
                throw new Error("regl rootNode was undefined on update...");
            console.log('Reglframe update!!!!!');
            _this.rootNode.containerInfo.render();
        });
    };
    ReglFrame.prototype.render = function () {
        var _this = this;
        // if user has passed an explicit canvas ref
        // or width && height have been omitted
        // return null and let regls default full canvas handle it.
        if (this.props.canvasRef ||
            (!this.props.width && !this.props.height)) {
            return null;
        }
        // otherwise render a canvas node
        return (react_1.default.createElement("canvas", { ref: function (canvasRef) {
                if (canvasRef) {
                    _this.canvasRef = canvasRef;
                    if (_this.props.forwardedRef) {
                        _this.props.forwardedRef(canvasRef);
                    }
                }
            }, width: this.props.width, height: this.props.height }));
    };
    ReglFrame.childContextTypes = {
        reactify: prop_types_1.default.bool
    };
    return ReglFrame;
}(react_1.default.Component));
exports.ReglFrame = ReglFrame;
